import { useEffect, useState } from 'react';

function readHudZoomFactor(): number {
	if (typeof document === 'undefined') return 1;
	const zoomValue = getComputedStyle(document.body)
		.getPropertyValue('--zoom-factor')
		.trim();
	if (!zoomValue) return 1;
	const parsed = parseFloat(zoomValue);
	return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

const useZoomFactor = () => {
	const [zoomFactor, setZoomFactor] = useState(() => readHudZoomFactor());

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const body = document.body;
		const updateZoom = () => {
			setZoomFactor(readHudZoomFactor());
		};

		updateZoom();

		const observer = new MutationObserver(updateZoom);
		observer.observe(body, {
			attributes: true,
			attributeFilter: ['style'],
		});

		return () => observer.disconnect();
	}, []);

	return zoomFactor;
};

export { readHudZoomFactor, useZoomFactor };
